export enum FilterProperty {
  Sku = "sku",
  Brand = "brand.name",
  Model = "model",
  MainCategory = "category.mainCategory",
  SubCategory = "category.subCategory",
  Edition = "edition",
}
